import loadCharacteristicAdjsHarness from './loadCharacteristicAdjsHarness'
import loadCharacterCharacteristicProps from './loadCharacterCharacteristicProps'
import loadCharacterCharacteristicValues from './loadCharacterCharacteristicValues'
import loadCharacterEquippedArmour from './loadCharacterEquippedArmour'
import loadSkillAdjsHarness from './loadSkillAdjsHarness'
import loadAbilityAdjs from './loadAbilityAdjs'
import normalizeCharacteristicSkillAdjs from './normalizeCharacteristicSkillAdjs'
import syncArmourDexCharacteristicSkillAdj from './syncArmourDexCharacteristicSkillAdj'
import loadTraits from './loadTraits'

import store from '../store/index'
//-----------------------
// load character values
//-----------------------
export default function loadCharacterValues(existing) {
  console.log('-----------------------')
  console.log('IN loadCharacterValues')

  const hydratedCharacters = loadCharacterCharacteristicValues(
    loadCharacterCharacteristicProps([existing]),
  )
  existing = hydratedCharacters[0] ?? existing

  //-----------------------------------
  // get specific race characteristics
  //-----------------------------------
  const raceId = existing?.race?.id ?? existing?.race ?? null
  let race_chars = store.getters['races/getRaceCharacteristics'](raceId)
  const safeRaceChars = Array.isArray(race_chars) ? race_chars : []
  const findRaceCharacteristic = (name) =>
    safeRaceChars.find((characteristic) => characteristic.name == name) || null
  let race_str = findRaceCharacteristic('str')
  let race_con = findRaceCharacteristic('con')
  let race_dex = findRaceCharacteristic('dex')
  let race_siz = findRaceCharacteristic('siz')
  let race_int = findRaceCharacteristic('int')
  let race_pow = findRaceCharacteristic('pow')
  let race_cha = findRaceCharacteristic('cha')
  //-----------------------------------
  // get characteristic mins and maxs
  //-----------------------------------
  existing['str_min'] = race_str?.min ?? existing['str_min'] ?? 0
  existing['str_max'] = race_str?.max ?? existing['str_max'] ?? 0

  existing['con_min'] = race_con?.min ?? existing['con_min'] ?? 0
  existing['con_max'] = race_con?.max ?? existing['con_max'] ?? 0

  existing['dex_min'] = race_dex?.min ?? existing['dex_min'] ?? 0
  existing['dex_max'] = race_dex?.max ?? existing['dex_max'] ?? 0

  existing['siz_min'] = race_siz?.min ?? existing['siz_min'] ?? 0
  existing['siz_max'] = race_siz?.max ?? existing['siz_max'] ?? 0

  existing['int_min'] = race_int?.min ?? existing['int_min'] ?? 0
  existing['int_max'] = race_int?.max ?? existing['int_max'] ?? 0

  existing['pow_min'] = race_pow?.min ?? existing['pow_min'] ?? 0
  existing['pow_max'] = race_pow?.max ?? existing['pow_max'] ?? 0

  existing['cha_min'] = race_cha?.min ?? existing['cha_min'] ?? 0
  existing['cha_max'] = race_cha?.max ?? existing['cha_max'] ?? 0
  //------------------------------------------
  // load backend-persisted wounds for display
  //------------------------------------------
  existing['con_wounds_tot'] = existing.wounds ?? 0
  if (!Object.hasOwn(existing, 'fatigue_override')) {
    existing['fatigue_override'] = null
  }
  if (existing.fatigue_override === '') {
    existing.fatigue_override = null
  }
  //-------------------------------------------------
  // def characteristic adjs array (to be populated)
  //-------------------------------------------------
  existing['characteristic_adjs'] = []
  //----------------------------------------------------
  // load characteristic adjs/reasons (rune + non-rune)
  //----------------------------------------------------
  console.log('off to load characteristic adjs harness...')
  existing = loadCharacteristicAdjsHarness(existing)
  console.log(
    'back from loading characteristic adjs = ',
    window.$deepCopy(existing.characteristic_adjs),
  )

  existing.characteristic_skill_adjs = normalizeCharacteristicSkillAdjs(
    existing.characteristic_skill_adjs,
  )

  // console.log('XYZ character skills = ', window.$deepCopy(existing.skills))
  //--------------------------------------------------------------------
  // load ability adjs (sum values/concatenate reasons) rune + non-rune
  //--------------------------------------------------------------------
  existing = loadAbilityAdjs(existing)
  //------------------
  // load skills adjs
  //------------------
  existing = loadSkillAdjsHarness(existing)
  //-------------
  // load traits
  //-------------
  existing = loadTraits({ character: existing })
  //----------------------
  // load equipped armour
  //----------------------
  existing = loadCharacterEquippedArmour({ character: existing })
  existing = syncArmourDexCharacteristicSkillAdj(existing)

  // console.log('ABC character counts = ', window.$deepCopy(existing.counts))

  return existing
}
